import request from '@/apis/axios'
import type { IResponse } from '@/apis/axios/config'
import type {
  RefreshTokenParam,
  RefreshTokenResult,
  UserDeleteParam,
  UserDeleteResult,
  UserLoginParam,
  UserLoginResult,
} from '~/apis/auth/type'

/**
 * 2.2.1 로그인 처리
 */
export const userLogin = (
  params: UserLoginParam,
): Promise<IResponse<UserLoginResult>> => {
  return request.get({ url: '/jadooApiV1/userLogin', params })
}
/**
 * 2.3.5 회원 탈퇴
 */
export const userDelete = (
  data: UserDeleteParam,
): Promise<IResponse<UserDeleteResult>> => {
  return request.delete({ url: '/jadooApiV1/userInfo', data })
}
/**
 * 2.1.2 access, 자두 토큰 갱신
 * */
export const commonRefreshToken = (
  data: RefreshTokenParam,
): Promise<IResponse<RefreshTokenResult>> => {
  return request.post({ url: '/jadooApiV1/commonTokenInfo', data })
}
